'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var IconPicture = function IconPicture(_ref) {
  var color = _ref.color,
      custom = _objectWithoutProperties(_ref, ['color']);

  return _react2.default.createElement(
    'svg',
    _extends({ fill: 'none', height: '24', viewBox: '0 0 24 24', width: '24' }, custom),
    _react2.default.createElement(
      'g',
      { fill: color },
      _react2.default.createElement('path', { d: 'M4.00780543,18.0479999 L19.7438054,18.0479999 L19.7438054,5.1999999 L4.00780543,5.1999999 L4.00780543,18.0479999 Z M20.5438054,19.6479999 L3.20780543,19.6479999 C2.76780543,19.6479999 2.40780543,19.2879999 2.40780543,18.8479999 L2.40780543,4.3999999 C2.40780543,3.9599999 2.76780543,3.5999999 3.20780543,3.5999999 L20.5438054,3.5999999 C20.9838054,3.5999999 21.3438054,3.9599999 21.3438054,4.3999999 L21.3438054,18.8479999 C21.3438054,19.2879999 20.9838054,19.6479999 20.5438054,19.6479999 L20.5438054,19.6479999 Z' }),
      ' ',
      _react2.default.createElement('path', { d: 'M20.0158054,16.7599999 C19.8318054,16.7599999 19.6478054,16.6959999 19.4958054,16.5679999 L16.2798054,13.8079999 L12.2798054,16.4799999 L7.19980543,11.0159999 L3.78380543,14.5439999 C3.47180543,14.8639999 2.96780543,14.8719999 2.65580543,14.5679999 C2.33580543,14.2559999 2.32780543,13.7519999 2.63180543,13.4319999 L7.22380543,8.6879999 L12.5278054,14.3919999 L16.3998054,11.8079999 L20.5358054,15.3519999 C20.8718054,15.6399999 20.9118054,16.1439999 20.6238054,16.4799999 C20.4638054,16.6639999 20.2398054,16.7599999 20.0158054,16.7599999' }),
      ' ',
      _react2.default.createElement('path', { d: 'M12.8318054,7.3999999 C12.1278054,7.3999999 11.5598054,7.9679999 11.5598054,8.6719999 C11.5598054,9.3679999 12.1278054,9.9359999 12.8318054,9.9359999 C13.5278054,9.9359999 14.0958054,9.3679999 14.0958054,8.6719999 C14.0958054,7.9679999 13.5278054,7.3999999 12.8318054,7.3999999 Z M12.8318054,11.5359999 C11.2478054,11.5359999 9.95980543,10.2559999 9.95980543,8.6719999 C9.95980543,7.0879999 11.2478054,5.7999999 12.8318054,5.7999999 C14.4078054,5.7999999 15.6958054,7.0879999 15.6958054,8.6719999 C15.6958054,10.2559999 14.4078054,11.5359999 12.8318054,11.5359999 L12.8318054,11.5359999 Z' }),
      ' '
    )
  );
};

IconPicture.propTypes = {
  color: _propTypes2.default.string
};

IconPicture.defaultProps = {
  color: _colors2.default.icons
};

IconPicture.displayName = 'IconPicture';

exports.default = IconPicture;
module.exports = exports.default;